/**
 * 管理画面・申請詳細で formData のキーを日本語ラベルに変換
 */
export const FORM_FIELD_LABEL_JA = {
    // 共通・住所
    oldZipCode: '旧郵便番号',
    oldAddress: '旧住所（漢字）',
    oldAddressKana: '旧住所（フリガナ）',
    newZipCode: '新郵便番号',
    newAddress: '新住所（漢字）',
    newAddressKana: '新住所（フリガナ）',
    created_at: '申請日',
    create_at: '申請日',
    // 名前
    oldName: '旧氏名',
    oldKanaName: '旧氏名（フリガナ）',
    newName: '新氏名',
    newKanaName: '新氏名（フリガナ）',
    // 銀行
    bankName: '銀行名',
    branchName: '支店名',
    branchNameKana: '支店名（フリガナ）',
    accountNumber: '口座番号',
    desiredDate: '変更希望日',
    // 入社・通勤
    startDate: '入社日',
    endDate: '退職日',
    name: '氏名',
    nameFuri: 'フリガナ',
    birthDate: '生年月日',
    zipCode: '郵便番号',
    address: '住所',
    contact1: '連絡先1',
    contact2: '連絡先2',
    transport: '交通機関名',
    road: '路線名',
    station: '乗車駅名～下車駅名',
    fare: '定期代金',
    extraTrains: '追加の利用機関',
    applicationDate: '申請日・取得日・異動日',
    reason: '理由',
    // 交通機関
    transport1: '交通機関名（1）',
    road1: '路線名（1）',
    station1: '乗車駅～下車駅（1）',
    fare1: '定期代金（1）',
    transport2: '交通機関名（2）',
    road2: '路線名（2）',
    station2: '乗車駅～下車駅（2）',
    fare2: '定期代金（2）',
    transport3: '交通機関名（3）',
    road3: '路線名（3）',
    station3: '乗車駅～下車駅（3）',
    fare3: '定期代金（3）',
    routes: '通勤経路',
    totalFare: '定期代合計',
    // 家族
    changeType: '異動区分',
    familyMembers: '扶養家族',
    familyMembersCount: '家族人数',
    relation: '続柄',
    nameKanji: '氏名（漢字）',
    nameKana: '氏名（フリガナ）',
    // マイナンバー
    myNumber: '個人番号',
    image: '本人確認書類',
    // 特別休暇
    start_date: '開始日',
    end_date: '終了日',
    // 残業申請
    overtime_date: '残業日',
    overtime_end_time: '残業終了予定時刻',
    scheduled_end: '残業開始時間',
    overtime_end: '残業終了時刻（申告）',
    actual_end: '退勤時間',
    overtime_hours: '残業時間',
    break_hours: '休憩時間',
    overtimeMinutes: '残業時間（分）',
    deviation_reason: '予定と異なる理由',
    overtime_source: '残業時間の算出方法',
    supervisor_skipped: '上司承認の省略',
    // 早退申請
    early_out_date: '早退日',
    early_out_hours: '早退時間',
    earlyLeaveMinutes: '早退時間（分）',
    // 遅刻申請
    late_date: '遅刻日',
    late_hours: '遅刻時間',
    lateMinutes: '遅刻時間（分）',
    // 共通（時刻）
    startTime: '開始時刻',
    endTime: '終了時刻',
    date: '対象日',
    attachment: '添付ファイル',
    // 有給
    selectedDates: '有給日',
    days: "日数",
    application_date: "申請日",
    // 休日出勤
    // ※ selectedDates / reason は有給・他カテゴリと共通のキー。ここで再定義すると
    //   フラット辞書が後勝ちで上書きされ、有給の「有給日」や各申請の「理由」が
    //   「休日出勤日」「休日出勤理由」に化ける。休日出勤専用ラベルは
    //   下の CATEGORY_LABEL_OVERRIDE.HOLIDAY_WORK に置くこと。
    workStartTime: "休日出勤時間",
    workEndTime: "休日退勤時間",
    breakTime: "休日休憩時間",
    isFurikae: "振替休日",
    substituteDate: "振替日",
    substituteDates: "振替日",

    // 交通費/経費
    // 交通（routes 内のキー）
    transportName: "交通機関名",
    route: "路線名",
    stationFrom: "乗車駅名",
    stationTo: "下車駅名",
    // 日帰り申請
    targetDate: "日付",
    businessPurpose: "出張用件",
    businessStartTime: "出張開始時刻",
    businessEndTime: "出張終了時刻",
    trainName: "利用列車",
    amount: "金額",
    // 諸手当
    familyAllowance: "家族手当",
    housingAllowance: "住宅手当",
    dispatchAllowance: "派遣手当",
    cityAllowance: "都市手当",
    qualificationAllowance: "資格手当",
    totalAllowance: "合計",
};

/** 諸手当（ALLOWANCE）の金額フィールド */
const ALLOWANCE_KEYS = new Set([
    'familyAllowance', 'housingAllowance', 'dispatchAllowance',
    'cityAllowance', 'qualificationAllowance', 'totalAllowance',
]);

/** 特別休暇・理由コード → 日本語 */
export const SPECIAL_LEAVE_REASON_JA = {
    BEREAVEMENT: "忌引(家族の不幸)",
    MARRIAGE: "結婚",
    CHILDBIRTH: "出産",
    CHILDCARE: "子供看護",
    kaigo: "介護",
    fresh: "リフレッシュ",
    newyear: "年末年始",
    seri: "生理休暇",
    BIRTHDAY: "バースデイ休暇",
    OTHER: "その他",
};

/** 定期代金として数値フォーマット（3桁コンマ＋円）が必要なキー */
const FARE_KEYS = new Set([
    'fare', 'fare1', 'fare2', 'fare3', 'totalFare',
]);

/** 定期代金値をフォーマット */
function formatFare(val) {
    const n = Number(val);
    if (isNaN(n)) return String(val);
    return `${n.toLocaleString('ja-JP')} 円`;
}

/** カテゴリ別ラベル上書き */
const CATEGORY_LABEL_OVERRIDE = {
    VACATION: {
        start_date: '有給日（開始）',
        end_date:   '有給日（終了）',
        reason:     '申請理由',
    },
    //　早退
    EARLY_OUT: {
        startTime: '早退時刻',
        endTime:   '予定終了時刻',
    },
    //遅刻
    LATE_IN: {
        startTime: '業務開始時刻',
        endTime:   '予定開始時刻',
    },
    // 休日出勤だけ selectedDates / reason のラベルを変える。
    // フラット辞書で再定義すると他カテゴリを壊すため、必ずここで上書きする。
    HOLIDAY_WORK: {
        selectedDates: '休日出勤日',
        reason:        '休日出勤理由',
    },
    RETIREMENT: {
        startDate:  '入社日',
        start_date: '入社日',
        endDate:    '退社日',
        end_date:   '退社日',
    },
    REMOVE: {
        applicationDate:  '異動年月日',
        application_date: '異動年月日',
    },
    TRANSPORT_ROUND: {
        routes: '利用交通機関',
    },
};

export function labelJa(key) {
    if (!key || typeof key !== 'string') return String(key);
    if (FORM_FIELD_LABEL_JA[key]) return FORM_FIELD_LABEL_JA[key];
    return key
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (s) => s.trim())
        .trim();
}

/** カテゴリを考慮したラベル取得 */
export function labelJaForCategory(category, key) {
    const override = CATEGORY_LABEL_OVERRIDE[category];
    if (override && override[key]) return override[key];
    return labelJa(key);
}

/** YYYY-MM-DD または YYYY/MM/DD 形式の日付文字列を日本語表記（YYYY年MM月DD日）に変換 */
function formatDateString(val) {
    const s = String(val);
    const m = s.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/);
    if (!m) return s;
    return `${m[1]}年${String(m[2]).padStart(2, '0')}月${String(m[3]).padStart(2, '0')}日`;
}

function formatScalar(val) {
    if (val === null || val === undefined) return '—';
    if (typeof val === 'boolean') return val ? 'はい' : 'いいえ';
    const s = String(val);
    if (/^\d{4}[-/]\d{1,2}[-/]\d{1,2}$/.test(s)) return formatDateString(s);
    return s;
}

/**
 * オブジェクト・配列を印刷向けテキストに（ネストはインデント）
 */
/** 特別休暇の理由値を日本語化 */
export function formatSpecialLeaveReason(val) {
    if (val === null || val === undefined) return "—";
    const s = String(val);
    return SPECIAL_LEAVE_REASON_JA[s] || s;
}

export function formatFormValueDisplay(val, depth = 0, options = {}) {
    if (val === null || val === undefined) return '—';
    if (typeof val === 'boolean') return val ? 'はい' : 'いいえ';
    if (Array.isArray(val)) {
        if (val.length === 0) return '—';
        return val
            .map((item, i) => {
                if (item !== null && typeof item === 'object' && !Array.isArray(item)) {
                    const inner = Object.entries(item)
                        .map(([k, v]) => `${labelJa(k)}：${formatFormValueDisplay(v, depth + 1, options)}`)
                        .join('　');
                    return `【${i + 1}】${inner}`;
                }
                return `【${i + 1}】${formatScalar(item)}`;
            })
            .join('\n');
    }
    if (typeof val === 'object') {
        return Object.entries(val)
            .map(([k, v]) => `${labelJa(k)}：${formatFormValueDisplay(v, depth + 1, options)}`)
            .join('\n');
    }
    return formatScalar(val);
}

/** 残業時間をどう確定したか（overtime_source の値）の日本語表記 */
const OVERTIME_SOURCE_JA = {
    punch: '退勤打刻から自動計算',
    manual: '手入力',
};

/** ネストあり・理由の日本語化用ラッパー */
export function formatFormValueDisplayForCategory(category, key, val, depth = 0) {
    if (category === "SPECIAL_LEAVE" && key === "reason") {
        return formatSpecialLeaveReason(val);
    }
    // 残業時間の算出方法は内部値（punch 等）なので日本語に置き換える
    if (key === "overtime_source") {
        return OVERTIME_SOURCE_JA[String(val)] || String(val ?? '—');
    }
    // 日帰り申請の金額はコンマ・円フォーマット
    if (category === "TRANSPORT_ROUND" && key === "amount") {
        return formatFare(val);
    }
    // 諸手当の金額はコンマ・円フォーマット
    if (category === "ALLOWANCE" && ALLOWANCE_KEYS.has(key)) {
        return formatFare(val);
    }
    // 日帰り申請の利用交通機関（routes配列）を整形表示
    if (category === "TRANSPORT_ROUND" && key === "routes" && Array.isArray(val)) {
        if (val.length === 0) return '—';
        return val.map((item, i) => {
            if (!item || typeof item !== 'object') return `【${i + 1}】${String(item)}`;
            const seg = `${item.stationFrom || '?'}～${item.stationTo || '?'}`;
            const round = item.roundTrip ? '（往復）' : '（片道）';
            return `【${i + 1}】${item.transportName || ''}　${seg}　${formatFare(item.fare)}${round}`;
        }).join('\n');
    }
    // 交通機関カテゴリの定期代フィールドはコンマ・円フォーマット
    if (category === "COMMUTE" && FARE_KEYS.has(key)) {
        return formatFare(val);
    }
    // 入社届の定期代フィールドもコンマ・円フォーマット
    if ((category === "joined" || category === "JOINED") && FARE_KEYS.has(key)) {
        return formatFare(val);
    }
    // 入社届の extraTrains 配列内の fare も同様にフォーマット
    if (
        (category === "joined" || category === "JOINED") &&
        key === "extraTrains" &&
        Array.isArray(val)
    ) {
        if (val.length === 0) return '—';
        return val.map((item, i) => {
            if (!item || typeof item !== 'object') return `【${i + 2}】${String(item)}`;
            const inner = Object.entries(item)
                .map(([k, v]) => {
                    const label = labelJa(k);
                    const formatted = FARE_KEYS.has(k) ? formatFare(v) : String(v ?? '—');
                    return `${label}：${formatted}`;
                })
                .join('　');
            return `【${i + 2}】${inner}`;
        }).join('\n');
    }
    // routes 配列内の fare も同様にフォーマット
    if (category === "COMMUTE" && key === "routes" && Array.isArray(val)) {
        return val.map((item, i) => {
            if (!item || typeof item !== 'object') return `【${i + 1}】${String(item)}`;
            const inner = Object.entries(item)
                .map(([k, v]) => {
                    const label = labelJa(k);
                    const formatted = FARE_KEYS.has(k) ? formatFare(v) : String(v ?? '—');
                    return `${label}：${formatted}`;
                })
                .join('　');
            return `【${i + 1}】${inner}`;
        }).join('\n');
    }
    return formatFormValueDisplay(val, depth, { category });
}
